// extracted by mini-css-extract-plugin
export default {"texts":"about_texts__fu6l8","card":"about_card__R2miE"};